import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssistedSelfServiceInvitation } from '../../../customer/MVDNow/assisted-self-service-invitations/models/assisted-self-service-invitation.model';
import { AssistedSelfServiceType } from '../../models/assisted-self-service-invitation/assisted-self-service-type.model';
import { AddAssistedSelfServiceInvitation } from '../../models/assisted-self-service-invitation/add-assisted-self-service-invitation.model';

@Injectable()
export class AssistedSelfServiceInvitationService extends BaseApiService {
    private baseRoute = 'Customer/AssistedSelfService';
    constructor() {
        super();
    }

    addAssistedSelfServiceInvitation(model: AddAssistedSelfServiceInvitation) {
        return this.post(this.baseRoute + '/invitations', model);
    }

    expireAssistedSelfServiceInvitation(assistedSelfServiceInvitationId: number) {
        return this.post(this.baseRoute + '/invitations/' + assistedSelfServiceInvitationId + '/expire', null);
    }

    getCustomerAssistedSelfServiceInvitations(customerNumberId: number): Observable<AssistedSelfServiceInvitation[]> {
        return this.get(this.baseRoute + '/invitations?customerNumberId=' + customerNumberId).pipe(map((response: any) => response.result));
    }

    getCustomerAssistedSelfServiceTypes(): Observable<AssistedSelfServiceType[]> {
        return this.get(this.baseRoute + '/types').pipe(map((response: any) => response.result));
    }

    getCustomerPrimaryAccount(customerNumberId: number) {
        return this.get('Customer/Account/CustomerNumber/' + customerNumberId + '/Primary');
    }

    isCustomerDeceased(customerNumberId: number) {
        return this.get('Customer/External/AssistedSelfService' + '/' + customerNumberId + '/deceasedstatus').pipe(map((response: any) => response.result));
    }
}
